
/**
 * @fileOverview ResizeListener module definition
 *
 * @author Jeff Maki <jmaki@nerdery.com>
 *
 * NOTE: THIS REQUIRE MODULE IS NAME SPACED, AND NEEDS TO HAVE ITS WRAPPER FUNCTION REMOVED IN ORDER TO REUSE ELSEWHERE *
 *
 * @version 1.0
 *
 */

(function (context) {
    'use strict';

    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('models/ResizeListener',['require','jquery','lib-thirdparty/modernizr-2.6.2','underscore','GlobalEventDispatcher'],function (require) {
        var $ = require('jquery');
        require('lib-thirdparty/modernizr-2.6.2');
        var _ = require('underscore');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');
        //require('lib/Util');

        /**
         * This is a simple ResizeListener that fires off a global 'resize' event when the window is resized, it uses
         * underscores 'debounce' function in order to keep the event from triggering too often. In addition it tracks the
         * current 'Context' state, which can be accessed via its getCurrentContext function.  In the case that the resize event
         * results in the application changing context, the ResizeListenter also publishes the new context that the application
         * is in leveraging the GlobalEventDispatcher.
         *
         * @class ResizeListener
         * @param time {int} Sets how often the resize event will be tracked, by default it is 1/10th of a second
         * @constructor
         */
        var ResizeListener = function (time) {

            /**
             * The global instance of an event dispatcher, used to subscribe to or publish events of global interest
             *
             * @default GlobalEventDispatcher.getEventDispatcher()
             * @property eventDispatcher
             * @type {jQuery}
             */
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();

            /**
             * The delay between resize events being published during a window resize.
             *
             * @default 100
             * @property timeDuration
             * @type {int}
             */
            this.timeDuration = time || 100;

            /**
             * A flag that checks to see if the ResizeListener is currently enabled, determines if it should publish
             * events or not.
             *
             * @default false
             * @property isEnabled
             * @type {Boolean}
             */
            this.isEnabled = false;

            /**
             * The current width of the browser window, used to check the context that the browser is currently in and
             * to see if that context needs to be updated after a resize event.
             *
             * @default 0
             * @property currentWidth
             * @type {Number}
             */
            this.currentWidth = 0;

            /**
             * The current context of the application,
             * values ['smallContext', 'mediumContext', 'largeContext', luxuryContext' ]
             *
             * @default largeContext
             * @property currentContext
             * @type {String}
             */
            this.currentContext = 'largeContext';

            /**
             * The current context of the application defined for new breakpoints viz. 1) 1 - 479px  2) 480 - 889px  3) > 890px,
             * values ['smallModifiedContext', 'mediumModifiedContext', 'largeModifiedContext', luxuryModifiedContext' ]
             *
             * @default luxuryModifiedContext
             * @property currentModifiedContext
             * @type {String}
             */

            this.currentModifiedContext = 'largeModifiedContext';


            this.init();
        };

        /**
         * initializes the ResizeListener
         *
         * @method init
         * @returns {ResizeListener}
         */
        ResizeListener.prototype.init = function () {

            if (Modernizr.mq('only all') === false || navigator.userAgent.indexOf('Trident/5')>-1) {
                return false;
            }
            this.setupListener()
                .checkSize()
                .checkModifiedSize()
                .enableListener();
        };

        /**
         * Attaches an event listener to the window, uses debounce to ensure that the event it not sent to the app more
         * often then the rimeDuration variable that is passed in when the ResizeListener is instantiated
         *
         * @method setupListener
         * @returns {ResizeListener}
         */
        ResizeListener.prototype.setupListener = function () {
            $(window).on('resize', _.debounce(this.publishEvent, this.timeDuration).bind(this));
            return this;
        };

        /**
         * Used to disable the publishing of events if needed.
         *
         * @method disableListener
         * @returns {ResizeListener}
         */
        ResizeListener.prototype.disableListener = function () {
            this.isEnabled = false;
            return this;
        };

        /**
         * Used to enable the publishing of events if needed.
         *
         * @method enableListener
         * @returns {ResizeListener}
         */
        ResizeListener.prototype.enableListener = function() {
            this.isEnabled = true;
            return this;
        };

        /**
         * This grabs the pseudo-element inserted into the DOM via CSS in the breakpoints
         * stylesheet. It will then, on resize, compare the returned string. If the string is the
         * same as the saved context, nothing happens. Otherwise a new event is published. Normalization
         * requires an or statement in the code to compare returned strings from all browsers except
         * IE and then IE browsers.
         *
         * @method checkSize
         * @returns {ResizeListener}
         */
        ResizeListener.prototype.checkSize = function() {
            this.currentWidthLabel = window.getComputedStyle(document.body, ':after').content;
            var newContext;

            // Here we have to check the string versus the passed in psuedo-element. Then we set the newContext
            // variable to the event. The reason for the or is the way that IE passes in the string, the string
            // is passed in with quotes.

            if (this.currentWidthLabel === 'smallContext' || this.currentWidthLabel === '"smallContext"' || this.currentWidthLabel === '\'smallContext\''){
                newContext = 'smallContext';
            } else if (this.currentWidthLabel === 'mediumContext' || this.currentWidthLabel === '"mediumContext"' || this.currentWidthLabel === '\'mediumContext\'') {
                newContext = 'mediumContext';
            } else if (this.currentWidthLabel === 'largeContext' || this.currentWidthLabel === '"largeContext"' || this.currentWidthLabel === '\'largeContext\'') {
                newContext = 'largeContext';
            } else if (this.currentWidthLabel === 'luxuryContext' || this.currentWidthLabel === '"luxuryContext"' || this.currentWidthLabel === '\'luxuryContext\'') {
                newContext = 'luxuryContext';
            }

            if (newContext === this.currentContext) {
                return this;
            } else {
                this.currentContext = newContext;
                this.eventDispatcher.publish(GlobalEventDispatcher.EVENTS.CONTEXT_CHANGE);
                this.eventDispatcher.publish(this.currentContext);
            }


            return this;

        };

        /** Designed for new Breakpoints viz. 1) 1 - 479px  2) 480 - 889px  3) > 890px
         * This grabs the pseudo-element inserted into the DOM (in the MMM--grid container) via CSS in the breakpoints
         * stylesheet. This is specifically defined for the new breakpoints It will then, on resize, compare the returned string. If the string is the
         * same as the saved context, nothing happens. Otherwise a new event is published. Normalization
         * requires an or statement in the code to compare returned strings from all browsers except
         * IE and then IE browsers.
         *
         * @method checkSize
         * @returns {ResizeListener}
         */
        ResizeListener.prototype.checkModifiedSize = function() {           

            var newModifiedContext;
            if ($('.MMM--themeWrapper').length !== 0) {
                this.currentModifiedWidthLabel = window.getComputedStyle(document.querySelector('.MMM--themeWrapper'), ':after').getPropertyValue('content');
            } 
            else {
                this.currentModifiedWidthLabel = 'largeModifiedContext';
            }  
            // Here we have to check the string versus the passed in psuedo-element. Then we set the newContext
            // variable to the event. The reason for the or is the way that IE passes in the string, the string
            // is passed in with quotes.
            if (this.currentModifiedWidthLabel === 'smallModifiedContext' || this.currentModifiedWidthLabel === '"smallModifiedContext"') {
                newModifiedContext = 'smallModifiedContext';
            } else if (this.currentModifiedWidthLabel === 'mediumModifiedContext' || this.currentModifiedWidthLabel === '"mediumModifiedContext"') {
                newModifiedContext = 'mediumModifiedContext';
            } else if (this.currentModifiedWidthLabel === 'largeModifiedContext' || this.currentModifiedWidthLabel === '"largeModifiedContext"') {
                newModifiedContext = 'largeModifiedContext';
            } else if (this.currentModifiedWidthLabel === 'luxuryModifiedContext' || this.currentModifiedWidthLabel === '"luxuryModifiedContext"') {
                newModifiedContext = 'luxuryModifiedContext';
            }
            if (newModifiedContext === this.currentModifiedContext) {
                return this;
            } else {
                this.currentModifiedContext = newModifiedContext;
                this.eventDispatcher.publish(GlobalEventDispatcher.EVENTS.MODIFIED_CHANGE);
                this.eventDispatcher.publish(this.currentModifiedContext);
            }


            return this;

        };


        /**
         * If the resizeListener is enabled, this publishes the resize event to the Applications event dispatcher,
         * any objects subscribed to this event will execute their callbacks.
         *
         * @method publishedEvent
         */
        ResizeListener.prototype.publishEvent = function () {
            this.checkSize();
            this.checkModifiedSize();
            if (!this.eventDispatcher) {
                throw new Error('Event dispatcher not defined');
            }

            if (this.isEnabled === true) {
                this.eventDispatcher.publish(GlobalEventDispatcher.EVENTS.WINDOW_RESIZE);
            }
        };

        /**
         * Provides a way for other objects to access the current context of an application, without a resize and
         * context change event having to occur.
         *
         * @method getCurrentContext
         * @return {String}
         */
        ResizeListener.prototype.getCurrentContext = function () {
            return this.currentContext;
        };


        /** Defined for new breakpoints  viz. 1) 1 - 479px  2) 480 - 889px  3) > 890px
         * Provides a way for other objects to access the current context of an application, without a resize and
         * context change event having to occur.
         *
         * @method getCurrentContext
         * @return {String}
         */
        ResizeListener.prototype.getCurrentModifiedContext = function () {
            return this.currentModifiedContext;
        };


        /**
         * Exposes the ability for the application to manually trigger the publish current context event
         *
         * @method triggerCurrentContext
         */
        ResizeListener.prototype.triggerCurrentContext = function () {
            this.eventDispatcher.publish(this.currentContext);
            this.eventDispatcher.publish(this.currentModifiedContext);
        };

        return ResizeListener;
    });

}(MMMRequire));

